define('formkit/view/form.object/common/design.form.object.top.view',['require','exports','module','uikit/uikit','underscore','../../../templates','./base.form.object.top.view','../../../behavior/template.object.remove.reorder.behavior','../../../behavior/tooltip.behavior'],function (require, exports, module) {
  var UIKit                               = require('uikit/uikit');
  var _                                   = require('underscore');
  var Templates                           = require('../../../templates');
  var BaseFormObjectTopView               = require('./base.form.object.top.view');
  var TemplateObjectRemoveReorderBehavior = require('../../../behavior/template.object.remove.reorder.behavior');
  var TooltipBehavior                     = require('../../../behavior/tooltip.behavior');

  var IndicatorView = UIKit.ItemView.extend({
    template: function() {
      return '<ui name="helpTextAppliedView" /> <ui name="affectedByRuleView" /> <ui name="ruleAppliedView" />'
    },

    internalViewOptions: {
      helpTextAppliedView: function() {
        return {
          type: UIKit.Button,
          circular: true,
          icon: 'help circle',
          visible: true,
          model: this.getOption('formObjectState'),
          bindings: {
            visible: 'hasHelpText'
          },
          behaviors: {
            TooltipBehavior: {
              content: 'Help text was applied to this object.',
              position: 'top center',
              variant: 'inverted',
              behaviorClass: TooltipBehavior
            }
          },
          stopPropagation: true
        }
      },
      affectedByRuleView: function() {
        return {
          type: UIKit.Button,
          icon: 'lightning',
          circular: true,
          visible: false,
          model: this.getOption('formObjectState'),
          bindings: {
            visible: 'isTargetedByCondition'
          },
          behaviors: {
            TooltipBehavior: {
              content: 'This object or one of its children is a target of a rule(s).',
              position: 'top center',
              variant: 'inverted',
              behaviorClass: TooltipBehavior
            }
          },
          stopPropagation: true
        }
      },
      ruleAppliedView: function() {
        return {
          type: UIKit.Button,
          icon: 'info circle',
          circular: true,
          visible: false,
          model: this.getOption('formObjectState'),
          bindings: {
            visible: 'hasRules'
          },
          behaviors: {
            TooltipBehavior: {
              content: 'This object has rule(s) applied to it.',
              position: 'top center',
              variant: 'inverted',
              behaviorClass: TooltipBehavior
            }
          },
          stopPropagation: true
        }
      }
    }

  });

  var ActionsView = UIKit.ItemView.extend({
    template: function() {
      return '<ui name="editButtonView"/><ui name="dragHandleView"/><ui name="ellipsisView"/>'
    },

    triggers: {
      'click .ui.button,.ui.dropdown': 'actionView:press'
    },

    options: {
      form: null,
      canEdit: true,
      canDrag: true,
      canDoAdditionalActions: true
    },

    internalViewBindings: {
      editButtonView: {
        visible: 'canEdit'
      },
      dragHandleView: {
        visible: 'canDrag'
      },
      ellipsisView: {
        visible: 'canDoAdditionalActions'
      }
    },

    internalViewOptions: {
      editButtonView: function() {
        return {
          type: UIKit.Button,
          stopPropagation: true,
          className: 'ui edit button',
          icon: 'pencil',
          circular: true
        }
      },
      dragHandleView: function() {
        return {
          type: UIKit.Button,
          stopPropagation: true,
          className: 'ui drag-handle button',
          icon: 'move',
          circular: true
        }
      },
      ellipsisView: function() {
        return {
          type: UIKit.Dropdown,
          model: this.model,
          form: this.form,
          childBindings: { text: 'text' },
          circular: true,
          iconOnly: true,
          icon: 'ellipsis horizontal',
          mode: 'button',
          pointing: 'right',
          size: 'small',
          behaviors: {
            TemplateObjectRemoveReorderBehavior: {
              behaviorClass: TemplateObjectRemoveReorderBehavior,
              enableActions: true,
              form: this.form
            }
          }
        }
      }
    }
  });

  var DesignFormObjectTopView = BaseFormObjectTopView.extend({
    options: _.extend(BaseFormObjectTopView.prototype.options, {
      designing: false,
      canEdit: true,
      canDrag: true,
      canDoAdditionalActions: true
    }),

    internalViewBindings: _.extend({}, BaseFormObjectTopView.prototype.internalViewBindings, {
      actionsView: {
        canEdit: 'canEdit',
        canDrag: 'canDrag',
        canDoAdditionalActions: 'canDoAdditionalActions'
      }
    }),

    internalViewOptions: BaseFormObjectTopView.extendInternalViewOptions({
      indicatorView: function() {
        return {
          type: IndicatorView,
          formObjectState: this.getOption('formObjectState')
        }
      },
      actionsView: function() {
        return {
          type: ActionsView
        }
      }
    })
  });

  module.exports = DesignFormObjectTopView;
});

